"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeSignalNameForComparison = normalizeSignalNameForComparison;
exports.foldSignalNameNotation = foldSignalNameNotation;
function normalizeSignalNameForComparison(name) {
    if (name === '') {
        return '';
    }
    return name
        .trim()
        .replace(/\u2212/g, '-')
        .toLowerCase();
}
const POLARITY_MARKS = /[#~!/*]/g;
const DASH_VARIANTS = /[‐‑‒–—―−]/g;
const LATEX_OVERLINE = /\\overline\{([^}]*)\}/g;
function foldSignalNameNotation(name) {
    if (name === '') {
        return '';
    }
    return (normalizeSignalNameForComparison(name)
        .replace(LATEX_OVERLINE, '$1')
        .normalize('NFD')
        .replace(/[̀-̲ͯ̅]/g, '')
        .replace(POLARITY_MARKS, '')
        .replace(DASH_VARIANTS, '-')
        .replace(/[\s_-]/g, ''));
}
//# sourceMappingURL=signal-name-normalization.js.map